import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#if this.item.url}}\n  <AvatarFlair @flairName={{this.item.name}} @flairUrl={{this.item.url}} @flairBgColor={{this.item.bgColor}} @flairColor={{this.item.color}} />\n{{/if}}\n\n<span>{{this.label}}</span>", {
  moduleName: "select-kit/components/selected-flair.hbs"
});